import IEnvConfig from "./IEnvConfig";

const ProdEnv: IEnvConfig = {
    baseBackendUrl: 'https://api.score.dimpl.io', // https://agreeable-pebble-094e4b103.1.azurestaticapps.net' // 'https://factor-prod-ariel-api.azurewebsites.net' (deleted, was in wrong resource group)
};

export default ProdEnv;
